import tw from 'twin.macro';
import {
  styled
} from 'styled-components';

export const FormContainer = styled.form`
  ${tw`flex flex-col gap-8 pb-6`}
`;
